<template>
  <div>
    <i class="fal fa-user fa-fw mr-2"></i>
    <span
      >{{ $t('EVENTS.LABEL.REGISTRATIONS') }}: {{ numberOfRegistrations }}</span
    >
    <span v-if="registrationLimit > 0">/{{ registrationLimit }}</span>
  </div>
</template>

<script>
export default {
  name: 'EventRegistrationsComponent',
  props: {
    numberOfRegistrations: {
      type: Number,
      default: 0,
    },
    registrationLimit: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped></style>
